import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { apolloClient } from '~/common/apollo-client'
import { useGlobalContext } from '~/common/hooks/useGlobalContext'
import { trackUserLogOut } from '~/common/utils/metrics'
import { useAuth } from './useAuth'

/**
 * Shared sign-out handler. Clears Apollo cache, signs out from active auth provider,
 * triggers logout in other tabs via localStorage, and navigates to login.
 */
export const useSignOutHandler = () => {
  const { user } = useGlobalContext()
  const { isSignedIn, signOut } = useAuth()
  const navigate = useNavigate()

  return useCallback(async () => {
    // Check if authenticated
    if (!isSignedIn) {
      navigate('/auth/login')
      return
    }

    // Sign out from active provider (this also sets localStorage event for cross-tab logout)
    await signOut()

    // Clear Apollo cache
    await apolloClient.clearStore()

    trackUserLogOut({ email: user?.email ?? null, phone: user?.phoneNumber ?? null })
    navigate('/auth/login')
  }, [isSignedIn, signOut, user, navigate])
}
